
import { json } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import { client } from "../models/contentful.server";
import { MetaFunction } from "@remix-run/cloudflare";
import ComponentBuilder from "@/components/ComponentBuilder";

export async function loader({params} : any){
	return json(await client.getPage("Lunch"))
}

export const meta : MetaFunction = ({data}) => {
	const {seoMetadata} = data;
	return {
		title: seoMetadata?.title || 'Cannoli Menu',
		description: seoMetadata?.description || '',
		"og:image": `${seoMetadata?.ogImage.url}`
	}
}

export default function Lunch() {
	const { blocksCollection } = useLoaderData();
	return (
		<>
			<ComponentBuilder blocks={blocksCollection?.items} />
		</>
	);
  }
